<template>
  <div class="404page full-screen">
    <div class="wrapper wrapper-full-page section content">
      <div class="w-100">
        <div class="container">
          <div
            class="row justify-content-center align-items-center"
            style="height: 100vh"
          >
            <div class="text-center">
              <div class="title404">{{ $t(`404.404`) }}</div>
              <div class="title font-weight-bold pb-2 text-capitalize">
                {{ $t(`404.ooops`) }}
              </div>
              <div class="title pb-4 text-uppercase">
                {{ $t(`404.message404`) }}
              </div>
              <router-link :to="{ name: routeName.HOME }">
                <b-button class="button btn-fill btn-primary text-capitalize">
                  {{ $t(`404.btn404`) }}
                </b-button>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ROUTE_NAME } from "@/core/constants";

export default {
  name: "NotFoundPage",
  data: () => ({
    routeName: ROUTE_NAME,
  }),
};
</script>

<style lang="scss">
.title404 {
  font-size: 100px;
  font-weight: unset !important;
}

.title {
  font-size: 1.2rem;
}
</style>
